module.exports = __webpack_public_path__ + "static/media/background-fix.ba135ee5.svg";